export const partnerIntegrationStates = {
  PENDING: 'pending',
  SYNCED: 'synced'
};

export const customerDeploymentStates = {
  DEPLOYED: 'deployed',
  NOT_DEPLOYED: 'not_deployed'
};
